import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../ReduxToolkit/Store';
import { authApi } from '../../Api';
import { localVariables } from '../../utils/Constant';

const RequireAuth: React.FC<{
    children: React.ReactNode;
}> = ({ children }) => {
    const { access_token, access_token_exp } = useSelector((state: RootState) => state.auth);
    const location = useLocation();
    let isTokenExpired = true;

    if (access_token_exp) isTokenExpired = access_token_exp * 1000 < new Date().getTime();

    if (!access_token || isTokenExpired) {
        localStorage.setItem(
            localVariables.REMEMBER_PATH,
            location.pathname + (location.search || '')
        );
        authApi.clearAuthData();

        return (
            <Navigate
                to={`${process.env.PUBLIC_URL}/login`}
                state={{ from: location }}
                replace
            />
        );
    }

    return <>{children}</>;
};

export default RequireAuth;
